import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Clock } from "lucide-react";
import api from "@/lib/api";
import { fmtDate } from "@/components/trial/TrialGate";

// Pricing page after the 10-min trial: ask the parent to choose a package and pay
export default function TrialEndedNote() {
  const [params] = useSearchParams();
  const id = params.get("trial_ended");
  const [st, setSt] = useState(null);
  useEffect(() => { if (id) api.get(`/children/${id}/trial`).then(({ data }) => setSt(data)).catch(() => {}); }, [id]);
  if (!id || !st || st.state === "paid") return null;
  const ended = st.state === "ended";
  return (
    <div className="mb-10 rounded-3xl border-4 border-slate-900 bg-[#FFDF00] p-6 shadow-[6px_6px_0_0_#111] flex gap-4 items-start" data-testid="pricing-trial-ended-note">
      <img src="/mascot/kiko.png" alt="" className="w-16 shrink-0" />
      <div>
        <p className="font-kids text-2xl font-black flex items-center gap-2"><Clock size={22} /> {ended ? `L'essai de ${st.child_name} est terminé` : `L'essai gratuit n'est plus disponible pour ${st.child_name}`}</p>
        <p className="mt-2">Choisissez votre formule ci-dessous et procédez au paiement pour que {st.child_name} {ended ? "continue à profiter" : "profite"} de l'accès.</p>
        <p className="text-sm text-slate-700 mt-1">{ended ? `${st.child_name}'s free trial is over.` : st.state === "former" ? "The free trial is only for children who never had a plan." : `The free trial was already used for Grade ${st.grade} on this account.`} Choose your package below and complete the payment to get access.</p>
        {ended && !st.reset && st.keep_until && (
          <p className="mt-3 inline-block rounded-2xl sm:rounded-full bg-white border-2 border-slate-900 px-4 py-1.5 text-sm font-bold" data-testid="pricing-trial-keep">
            Payez avant le {fmtDate(st.keep_until)} : toute sa progression est gardée. / Pay before {fmtDate(st.keep_until, "en")} to keep it.
          </p>
        )}
      </div>
    </div>
  );
}
